<template>
  <div class="cardmodal">
    <div ref="modalContent" class="cardmodal__wrapper">
      <button class="cardmodal__closebtn" @click="handleClick"></button>

      <div class="wrapper-tooltip">
      <img
        :src="
          useStrapiMediaUrl(
            store.dataModal?.attributes?.participant?.data?.attributes?.logo
              ?.data?.attributes?.url,
          )
        "
        class="cardmodal__company"
        loading="lazy"
      />
      
            </div>  
      <div class="cardmodal__content">
        <!--
 <img
          :src="
            url +
            store.dataModal?.attributes?.participant?.data?.attributes?.photo
              ?.data?.attributes.url
          "
          class="cardmodal__avatar"
        />
-->
        <h3 class="text-32 text-bold">
          {{
            store.dataModal?.attributes?.participant?.data?.attributes?.company
          }}
          <ClientOnly>
              <Tooltip
                v-if=" store.dataModal?.attributes?.participant?.data?.attributes
              ?.mark"
                :show-triggers="['click', 'touch', 'focus']"
                :hide-triggers="['focus']"
                :overflow-padding="30"
                placement="bottom"
                auto-boundary-max-size
                prevent-overflow
                class="tooltip"
              >
                <button class="tooltip__trigger">
                  <NuxtImg src="/img/icon_dots-vertical.svg" />
                </button>
                <template #popper>
                  <p
                    class="tooltip__content"
                    v-html="store.dataModal?.attributes?.participant?.data?.attributes
              ?.mark"
                  />
                </template>
              </Tooltip>
            </ClientOnly>
        </h3>
        <img
          :src="
            useStrapiMediaUrl(
              store.dataModal?.attributes?.nomination?.data?.attributes?.icon
                ?.data?.attributes?.url,
            )
          "
          class="cardmodal__nomination"
          loading="lazy"
        />

        <h4 class="text-32 text-normal">
          {{ store.dataModal?.attributes?.nomination?.data?.attributes?.name }}
        </h4>
        <div class="cardmodal__description">
          <div
            class="text-20 text-overflow"
            v-html="
              store.dataModal?.attributes?.participant?.data?.attributes
                ?.description
            "
          ></div>
          <NuxtLink
            v-if="
              store.dataModal?.attributes?.participant?.data?.attributes
                ?.website
            "
            :to="
              store.dataModal?.attributes?.participant?.data?.attributes
                ?.website
            "
            class="cardmodal__link"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Ссылка на сайт
          </NuxtLink>
          <NuxtLink
            v-if="
              store.dataModal?.attributes?.participant?.data?.attributes
                ?.ext_link
            "
            :to="
              store.dataModal?.attributes?.participant?.data?.attributes
                ?.ext_link
            "
            class="cardmodal__link-ext"
            target="_blank"
            rel="noopener noreferrer nofollow"
            >О компании</NuxtLink
          >
          <button class="cardmodal__share" @click="copyParticipantLink">
            Поделиться
          </button>
        </div>
      </div>
    </div>
    <div v-if="isCopyNoticeVisible" class="cardmodal__copy-notice">
      Ссылка скопирована в буфер обмена
    </div>
  </div>
</template>
<script setup lang="ts">
import { Tooltip } from "floating-vue"
import { useNominationPageStore } from "~/store/nominationPage"
const COPY_NOTICE_DURATION_MS = 3000
const store = useNominationPageStore()
const emit = defineEmits<{
  (e: "handleClosePreview"): void
}>()
const handleClick = () => {
  emit("handleClosePreview")
}
const participantId = computed(() => {
  const modalData = store.dataModal as { id?: number | string }
  return modalData?.id ? String(modalData.id) : ""
})
const isCopyNoticeVisible = ref(false)
let copyNoticeTimeout: ReturnType<typeof setTimeout> | null = null
const showCopyNotice = () => {
  isCopyNoticeVisible.value = true

  if (copyNoticeTimeout) {
    clearTimeout(copyNoticeTimeout)
  }

  copyNoticeTimeout = setTimeout(() => {
    isCopyNoticeVisible.value = false
    copyNoticeTimeout = null
  }, COPY_NOTICE_DURATION_MS)
}

const fallbackCopyText = (text: string) => {
  if (!import.meta.client) return false

  const textArea = document.createElement("textarea")
  textArea.value = text
  textArea.setAttribute("readonly", "")
  textArea.style.position = "fixed"
  textArea.style.top = "-9999px"
  textArea.style.left = "-9999px"
  textArea.style.opacity = "0"
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  textArea.setSelectionRange(0, text.length)

  let isCopied = false
  try {
    isCopied = document.execCommand("copy")
  } catch {
    isCopied = false
  }

  document.body.removeChild(textArea)
  return isCopied
}

const copyTextToClipboard = async (text: string) => {
  if (!import.meta.client) return false

  if (navigator.clipboard?.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {}
  }

  return fallbackCopyText(text)
}

const copyParticipantLink = async () => {
  if (!import.meta.client || !participantId.value) return

  const shareUrl = new URL(window.location.href)
  shareUrl.hash = participantId.value
  const isCopied = await copyTextToClipboard(shareUrl.toString())

  if (isCopied) {
    showCopyNotice()
  }
}
const modalContent = ref<HTMLElement | null>(null)
const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as Node | null

  if (modalContent.value && target && !modalContent.value.contains(target)) {
    handleClick()
  }
}
onMounted(() => {
  document.addEventListener("mousedown", handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener("mousedown", handleClickOutside)

  if (copyNoticeTimeout) {
    clearTimeout(copyNoticeTimeout)
  }
})
</script>
<style lang="scss">
.tooltip {
  &__trigger {
    background: none;
    border: none;
    padding: 0;
    margin: 0 0 0 8px;
    cursor: pointer;
    display: inline-block;
    width: 26px;
    height: 26px;
    background-color: gray;
  }
}
.cardmodal {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0e0e0e70;
  backdrop-filter: blur(20px);
  color: #ffffff;
  transition: 0.335s;
  h4 {
    margin: 0 0 14px 0;
  }
  &__wrapper {
    position: relative;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 44px;
    max-width: 960px;
    width: 100%;
    height: auto;
    max-height: 90vh;
    max-height: 90dvh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #0e0e0e;
    
    @include md {
      padding: 32px;
      height: 100vh;
      max-height: 100vh;
      border-radius: 0;
    }
  }
  &__content {
    min-height: 0;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    ul {
      li {
        margin: 0 0 10px 0;
      }
    }
  }
  &__description {
    min-height: 0;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    gap: 16px;
  }
  &__company {
    margin: 0 0 40px 0;
    display: block;
    width: 146px;
    height: 30px;
    object-fit: contain;
    object-position: left;
  }
  &__avatar {
    margin: 0 0 14px 0;
    display: block;
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  &__nomination {
    margin: 14px 0 14px 0;
    width: 44px;
    height: 34px;
  }
  &__link {
    margin: 14px 0 0 0;
    display: inline-block;
    text-decoration: underline;
    font-size: 12px;
    line-height: 16px;
    transition: ease-in-out 0.335s;
    &-ext {
      margin: 0 auto;
      display: block;
      // width: 100%;
      text-align: center;
      border: 1px solid #ffffff;
      padding: 10px 0;
      border-radius: 20px;
      margin: 20px 0 0 0;
      transition: .5s;
      &:hover {
        background-color: #ffffff;
        color: #0e0e0e;
      }
    }
    &:hover {
      opacity: 0.5;
    }
  }
  &__closebtn {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 15px;
    height: 15px;

    background-image: url("/img/close_cardModal.svg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    transition: ease-in-out 0.335s;
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
    @include sm {
      top: 30px;
      right: 30px;
    }
  }
  &__share {
    margin-top: auto;
    display: block;
    width: 100%;
    border-radius: 20px;
    border: 1px solid #ffffff;
    background-color: #ffffff;
    color: #000000;
    padding: 14px 20px;
    font-size: 16px;
    line-height: 20px;
    transition: ease-in-out 0.335s;

    &:hover {
      background-color: #5738cf;
      border-color: #5738cf;
      color: #ffffff;
    }
  }
  &__copy-notice {
    position: fixed;
    left: 50%;
    bottom: 12px;
    transform: translateX(-50%);
    border-radius: 20px;
    text-align: center;
    width: 250px;
    padding: 16px;
    background-color: #ffffff;
    color: #000000;
    font-size: 16px;
    line-height: 20px;
    z-index: 1000;
  }
}

.text-overflow {
  min-height: 220px;
  overflow-y: auto;
  flex: 1 1 auto;

   @include md {
      min-height: 0;
    }
}
</style>
